export default __webpack_public_path__ + "static/media/aboutJs2.61da6867.jpg";